export default __webpack_public_path__ + "static/media/pod-overview.9ed509d3.png";